import i18next from "i18next";

export enum BackUpOptions {
    ONLY_READ = 1,
    FULL_MANAGE = 2
}

export const BackUpOptionLabel = (key: string) => ({ 
    [BackUpOptions.ONLY_READ]: i18next.t('ONLY_READ'),
    [BackUpOptions.FULL_MANAGE]: i18next.t('FULL_MANAGE')
})[key];